class MixMatchBox extends HTMLElement {
    constructor() {
        super();
  
        this.querySelectorAll('button.close-button, button.close-button--full').forEach((closeButton) =>
          closeButton.addEventListener('click', this.close.bind(this))
        );
        this.querySelectorAll('.box-header').forEach((header) =>
          header.addEventListener('click', this.open.bind(this))
        );
      
      this.boxElement = this.querySelector("ul");
      this.price = "";
      this.originalPrice = "";
      this.savings = "";
      this.priceElement = this.querySelector("[data-total]");
      this.originalPriceElement = this.querySelector("[data-original]");
      this.savingsElement = this.querySelector("[data-save]");
      this.MixMatchElement = document.querySelector('mix-match');
  
  
    }
  
    addItemToBox(product) {
    }
    
      updatePrices(selectedProducts) {
        const totalPrice = selectedProducts.reduce((total, product) => 
          total + product.properties.price * product.quantity, 0);
          
        const totalOriginalPrice = selectedProducts.reduce((total, product) => 
          total + product.properties.originalPrice * product.quantity, 0);
          
        let discount = this.MixMatchElement.dataset.discount;
        const numDiscount = parseFloat(discount);
        if (!isNaN(numDiscount)) {
          discount = Math.round(numDiscount);
        }
      
        let formattedPrice = window.Currency.formatMoney(totalPrice, window.currencyFormat);
        let formattedOriginalPrice = window.Currency.formatMoney(totalOriginalPrice, window.currencyFormat);

        if (this.MixMatchElement.hasAttribute('data-show-german-different')) {
          const formatGerman = (moneyString) => {
            const currencySymbol = moneyString.replace(/[\d,.]/g, '').trim();
            let price = moneyString.replace(/[^\d,.]/g, '').trim();
            
            if (price.includes(',00')) {
              price = price.replace(/,00/, '');
            }
            return `${price}${currencySymbol} ${window.currency.inclVat}`;
          };
          formattedPrice = formatGerman(formattedPrice);
          formattedOriginalPrice = formatGerman(formattedOriginalPrice);
        }

        this.priceElement.textContent = formattedPrice;
        this.originalPriceElement.textContent = formattedOriginalPrice;
        this.savingsElement.textContent = `${discount}%`;
      }
    
      clearItems() {
        this.updatePrices([]);
        
        console.log("The mix-match box has been cleared.");
      }
  
    open() {
        this.classList.add('open');
        this.classList.remove('closed');
    }
  
    close() {
        this.classList.remove('open');
        this.classList.add('closed');
    }
  }
  
  customElements.define('mix-match-box', MixMatchBox);

  class MixMatchElement extends HTMLElement {
      constructor() {
        super();
        this.selectedProducts = []; // Stores selected products
          this.bundleId = ""; // Stores the bundle ID
          this.variantId = this.dataset.variant;
        this.identifier = ""; // Unique identifier for the bundle
        this.boxElement = null; // Reference to the box container
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer'); // Cart reference
        this.maxItems = parseInt(this.dataset.max);
        this.mixMatchBox = document.querySelector('mix-match-box');
        this.submitButton = null;
        this.spinner = null;
  
  
      }
    
      connectedCallback() {
        // Initialize the element
        this.bundleId = this.getAttribute("data-id");
        this.identifier = `${this.bundleId}_${Date.now()}`;
        this.boxElement = this.querySelector(".box ul");

        console.log('[mix-match] init', {
          bundleId: this.bundleId,
          bundleVariantId: this.dataset.variant,
          productHandle: this.dataset.productHandle,
          productId: this.dataset.productId,
          productsCount: this.dataset.productsCount,
          unresolvedProducts: this.dataset.unresolvedProducts,
          maxItems: this.maxItems,
        });

        if (Number(this.dataset.unresolvedProducts) > 0) {
          console.warn(
            '[mix-match] FoxSell products list: unresolved category product(s) in metafield — check products array vs category.products IDs',
            { unresolvedProducts: this.dataset.unresolvedProducts, productsCount: this.dataset.productsCount }
          );
        }
  
        this.loadBoxFromLocalStorage();
  
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.mixMatchBox.classList.add('in-viewport');
              } else if (entry.boundingClientRect.top > 0) {
                this.mixMatchBox.classList.remove('in-viewport');
              }
            });
          },
          { rootMargin: '0px 0px -50px 0px' }
        );
    
        observer.observe(this);
    
        // Attach event listeners to "add to box" buttons
        this.querySelectorAll('.mix-match-variant-radio').forEach((button) => {
          button.addEventListener("change", (e) => this.addToBox(e));
        });
    
        // Attach event listener to "add to cart" button
        this.submitButton = this.querySelector(".box button[type='submit']");
        this.submitButton.addEventListener('click', () => this.addToCart());
        this.spinner = this.submitButton.querySelector('.loading-overlay__spinner');
      }
    
      saveBoxToLocalStorage() {
        localStorage.setItem('mixMatchBox', JSON.stringify(this.selectedProducts));
        console.log("Box saved to localStorage.");
      }
    
    loadBoxFromLocalStorage() {
      return false;
        const savedBox = localStorage.getItem('mixMatchBox');
        if (savedBox) {
          this.selectedProducts = JSON.parse(savedBox);
          this.selectedProducts.forEach((product) => this.mixMatchBox.addItemToBox(product));
          this.updateUI();
          console.log("Box loaded from localStorage.");
        } else {
          console.log("No saved box found in localStorage.");
        }
      }
    
    updateUI() {
      this.updateSubmitButton();
      this.updateItemCount();
      this.updateRangeBar();
      this.updateQuantityButtons();
      this.mixMatchBox.updatePrices(this.selectedProducts);
      if (this.getItemCount() > 0) {
        this.mixMatchBox.classList.remove('empty');
      } else {
        this.mixMatchBox.classList.add('empty');
      }
      if (this.getItemCount() === this.maxItems) {
        
        this.mixMatchBox.open();
      }
      this.updateTitles();
      this.updateCategorySummaries();
    }
  
    emptyBox() {
      this.selectedProducts = [];
      this.mixMatchBox.clearItems();
      this.updateUI();
      this.saveBoxToLocalStorage();
  
      }
    
    updateCategorySummaries() {
      const productsByCategory = this.selectedProducts.reduce((acc, product) => {
        if (!acc[product.category]) {
          acc[product.category] = [];
        }
        acc[product.category].push(product.properties.productTitle);
        return acc;
      }, {});
  
      this.querySelectorAll('.category').forEach((categoryElement) => {
        const categoryTitle = categoryElement.dataset.title;
        const summaryElement = categoryElement.parentElement.querySelector('summary');
        const selectedProductsElement = summaryElement.querySelector('.selected-product');
        
        if (selectedProductsElement) {
          if (productsByCategory[categoryTitle]) {
            selectedProductsElement.textContent = productsByCategory[categoryTitle].join(', ');
          } else {
            selectedProductsElement.textContent = '';
          }
        }
      });
    }
    
    updateProductQuantity(variantId, newQuantity) {
        const product = this.selectedProducts.find((product) => product.variantId === variantId);
        if (product) {
          product.quantity = newQuantity;
        }
    
      // Update UI elements
      this.updateUI();
      this.saveBoxToLocalStorage();
  
      }
    
    removeItemFromBox(variantId) {
      const productIndex = this.selectedProducts.findIndex(product => product.variantId === variantId);
      if (productIndex > -1) {
        const product = this.selectedProducts[productIndex];
        if (product.quantity > 1) {
          product.quantity -= 1;
        } else {
          this.selectedProducts.splice(productIndex, 1);
        }
      }
  
      // Update UI
      console.log('removefrombox');
      this.updateUI();
      this.saveBoxToLocalStorage();
  
  
    }
  
    
      addToBox(event) {
          const radio = event.target;
          const variantId = parseInt(radio.value);
          const productParent = radio.closest(".card-wrapper");
          const categoryElement = radio.closest(".category");
          const categoryTitle = categoryElement.dataset.title;

          const existingProductIndex = this.selectedProducts.findIndex(p => p.category === categoryTitle);

          if (existingProductIndex > -1 && this.selectedProducts[existingProductIndex].variantId === variantId) {
            return;
          }

          if (existingProductIndex > -1) {
            this.selectedProducts.splice(existingProductIndex, 1);
          }
      
          const productTitle = productParent.dataset.title;
          let variant = '';
          if (productParent.querySelector('select')) {
            variant = productParent.querySelector('select').value;
          }
          const activeVariantPriceElement = productParent.querySelector('.variant-prices [data-variant]:not(.hidden)');
          const price = parseFloat(activeVariantPriceElement.dataset.price);
          const originalPrice = parseFloat(activeVariantPriceElement.dataset.originalPrice);
        
            const product = {
                variantId,
                quantity: 1,
                category: categoryTitle,
                type: 'product',
                productId: radio.dataset.productId,
                properties: {
                    productTitle,
                    price,
                    originalPrice,
                    variant,
                },
            };

            console.log('[mix-match] addToBox', {
              category: categoryTitle,
              variantId,
              productId: product.productId,
              radioValue: radio.value,
            });
        
          this.selectedProducts.push(product);
          this.mixMatchBox.addItemToBox(product);
        
        this.updateUI();
        this.mixMatchBox.updatePrices(this.selectedProducts);
        this.saveBoxToLocalStorage();

        const currentDetails = categoryElement.closest('details');
        if (currentDetails) {
          currentDetails.removeAttribute('open');
        }

        const allDetails = this.querySelectorAll('details');
        const selectedCategories = this.selectedProducts.map(p => p.category);

        let nextDetailsToOpen = null;
        for (const details of allDetails) {
          const categoryDiv = details.querySelector('.category');
          if (categoryDiv) {
            const categoryTitle = categoryDiv.dataset.title;
            if (!selectedCategories.includes(categoryTitle)) {
              nextDetailsToOpen = details;
              break; 
            }
          }
        }

        if (nextDetailsToOpen) {
          nextDetailsToOpen.setAttribute('open', '');
          
          setTimeout(() => {
            currentDetails.scrollIntoView({ behavior: 'smooth' });
          }, 250);
        }
      }
    
      getItemCount() {
        return this.selectedProducts.reduce((total, product) => total + product.quantity, 0);
      }
    
    updateQuantityButtons() {
      const quantityInputs = this.querySelectorAll('quantity-input');
      const itemCount = this.getItemCount();
      const remainingItems = this.maxItems - itemCount;
      if (remainingItems === 0) {
  
        quantityInputs.forEach((quantityInput) => {
          quantityInput.querySelector('button[name="plus"]').disabled = true;
        });
        
      } else {
        quantityInputs.forEach((quantityInput) => {
          quantityInput.querySelector('input[type="number"]').max = this.maxItems;
          quantityInput.querySelector('button[name="plus"]').disabled = false;
        });
      }
      }
    
      updateTitles() {
        const completeTitle = this.querySelector('.complete-title');
        const singleTitle = this.querySelector('.single-title');
        const defaultTitle = this.querySelector('.default-title');
      
        const itemCount = this.getItemCount();
        const remainingItems = this.maxItems - itemCount;
        const maxItems = this.maxItems;
      
  
        [completeTitle, singleTitle, defaultTitle].forEach((title) => {
          if (title) title.classList.add('hidden');
        });
      
        switch (true) {
          case itemCount === maxItems && !!completeTitle:
            completeTitle.classList.remove('hidden');
            break;
          case remainingItems === 1 && !!singleTitle:
            singleTitle.classList.remove('hidden');
            break;
          case remainingItems > 1 && !!defaultTitle:
            defaultTitle.classList.remove('hidden');
            const span = defaultTitle.querySelector('span');
            if (span) {
              span.textContent = `${remainingItems}`;
            }
            break;
          default:
            break;
        }
      }
    
    updateSubmitButton() {
      const maxItems = this.maxItems;
      const totalQuantity = this.getItemCount();
      const submitButton = this.querySelector('mix-match-box button[type="submit"]');
      if (submitButton) {
        submitButton.disabled = totalQuantity < maxItems;
      }
    }
    
    
    updateRangeBar() {
      this.rangeElement = this.querySelector('mix-match-box .range__inner');
        if (this.rangeElement) {
          const totalQuantity = this.getItemCount();
          const percentage = (totalQuantity / this.maxItems) * 100;
          this.rangeElement.style.width = `${Math.min(percentage, 100)}%`;
        }
      }
    
      updateItemCount() {
        const totalQuantity = this.getItemCount();
  
        const countElements = document.querySelectorAll('span[data-count]');
        countElements.forEach((element) => {
          element.textContent = totalQuantity;
        });
      }
    
      async addToCart() {
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        if (this.getItemCount() === 0) {
          alert("No products in the box to add to the cart.");
          return;
        }
      
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.handleErrorMessage(false);
        if (this.spinner) {
          this.spinner.classList.remove('hidden');
        }

        const bundleVariantId = Number(this.dataset.variant || this.variantId);

        const bundleLineItemProperties = this.selectedProducts.map((product) => ({
          variantId: product.variantId,
          quantity: product.quantity,
          category: product.category,
          type: product.type,
        }));

        const bundleItemsJson = JSON.stringify(bundleLineItemProperties);

        const addToCartFormData = {
          items: [
            {
              id: bundleVariantId,
              quantity: 1,
              properties: {
                '__foxsell:dynamic_add_on_bundle_id': this.identifier,
                '__foxsell:dynamic_add_on_bundle_items': bundleItemsJson,
              },
            },
          ],
        };

        const requestBody = {
          ...addToCartFormData,
          sections: this.cart?.getSectionsToRender?.().map((section) => section.id) ?? [],
          sections_url: window.location.pathname,
        };

        console.log('[mix-match] addToCart request', {
          bundleVariantId,
          bundleProductId: this.dataset.productId,
          foxsellBundleId: this.bundleId,
          foxsellIdentifier: this.identifier,
          productsCount: this.dataset.productsCount,
          unresolvedProducts: this.dataset.unresolvedProducts,
          itemCount: this.getItemCount(),
          bundleLineItemProperties,
          bundleItemsJson,
          requestBody,
        });

        if (!bundleVariantId) {
          console.error('[mix-match] Bundle variant ID is not defined.', this.dataset);
          this.handleErrorMessage('Bundle variant ontbreekt op de pagina.');
          this.submitButton.classList.remove('loading');
          this.submitButton.removeAttribute('aria-disabled');
          if (this.spinner) this.spinner.classList.add('hidden');
          return;
        }

        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify(requestBody),
          });

          const responseText = await response.text();
          let result;

          try {
            result = JSON.parse(responseText);
          } catch (parseError) {
            console.error('[mix-match] cart/add.js non-JSON response', {
              httpStatus: response.status,
              responseText,
            });
            throw new Error('Failed to add to cart');
          }

          console.log('[mix-match] cart/add.js response', {
            httpStatus: response.status,
            ok: response.ok,
            result,
          });

          if (!response.ok || result.status) {
            const selectedVariantIds = this.selectedProducts.map((p) => p.variantId);
            console.error('[mix-match] cart/add.js failed', {
              bundleVariantId,
              bundleItemsJson,
              foxsellBundleId: this.bundleId,
              selectedVariantIds,
              result,
            });
            if (this.bundleId === '68e632b04f6d9cd849c3b9c0') {
              console.error(
                '[mix-match] Barista Expert / FoxSell: parent variant can be added with empty addons, but cart tests show addon variant 55679494488447 (WDT-Tool) and 56312963891583 (Puck Screen) are rejected by FoxSell; 55679493144959 (Naked Portafilter) is accepted. The theme payload matches Boost. Re-save the bundle in FoxSell so WDT-Tool and Puck Screen map to variants the app allows, or update the product metafield if IDs changed.'
              );
            }
            this.handleErrorMessage(result.description || result.message);
            return;
          }
      
          this.mixMatchBox.close();
          this.emptyBox();
          this.cart?.renderContents?.(result);
        } catch (error) {
          console.error('[mix-match] addToCart error', error);
        } finally {
          this.submitButton.classList.remove('loading');
          this.submitButton.removeAttribute('aria-disabled');

          if (this.spinner) {
            this.spinner.classList.add('hidden');
          }
        }
      }
    
      handleErrorMessage(errorMessage = false) {
        const errorMessageWrapper =
          this.mixMatchBox?.querySelector('.error-message-wrapper') ||
          this.querySelector('.error-message-wrapper');
        const errorMessageElement = errorMessageWrapper?.querySelector('.error-message');
    
        if (errorMessageWrapper && errorMessageElement) {
          errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
          if (errorMessage) errorMessageElement.textContent = errorMessage;
        }
      }
    }
    
    // Define the custom element
  customElements.define("mix-match", MixMatchElement);
    
  class BoxOpener extends HTMLElement {
    constructor() {
        super();
        this.addEventListener('click', this.openBox);
        
    }
  
    openBox() {
        const mixMatchBox = document.querySelector('mix-match-box');
        if (mixMatchBox) {
            mixMatchBox.open();
        }
    }
  }
  
  customElements.define('box-opener', BoxOpener);
  
  
  